import { render, staticRenderFns } from "./thankyouPage.vue?vue&type=template&id=c87445f6&"
import script from "./thankyouPage.vue.ts?vue&type=script&lang=ts&"
export * from "./thankyouPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports